module.exports = __webpack_public_path__ + "media/notices/Repeción de SRC-1-8ce1c82b.jpg";